// assets
import { ApiOutlined, AuditOutlined, InteractionOutlined, PercentageOutlined, SafetyOutlined, TeamOutlined } from '@ant-design/icons';

// type
import { NavItemType } from 'types/menu';
import { Rights } from '../graphql/types';

// icons
const icons = {
  ApiOutlined,
  AuditOutlined,
  InteractionOutlined,
  PercentageOutlined,
  SafetyOutlined,
  TeamOutlined
};

// ==============================|| MENU ITEMS - SUPPORT ||============================== //

const settings: NavItemType = {
  id: 'settings',
  title: 'Settings',
  type: 'group',
  oneOfRights: [Rights.ListIntegrations, Rights.ManageUsers, Rights.IsSuperAdmin],
  children: [
    {
      id: 'users-list',
      title: 'Users',
      type: 'item',
      url: '/settings/users',
      icon: { anticon: icons.TeamOutlined },
      rights: [Rights.ManageUsers]
    },
    {
      id: 'audit-list',
      title: 'Users Activity',
      type: 'item',
      url: '/audit-logs',
      icon: { anticon: icons.AuditOutlined },
      rights: [Rights.IsSuperAdmin]
    },
    {
      id: 'integrations-list',
      title: 'Platforms',
      type: 'item',
      url: '/settings/integrations',
      icon: { anticon: icons.InteractionOutlined },
      rights: [Rights.ListIntegrations]
    },
    {
      id: 'external-integrations-list',
      title: 'Integrations',
      type: 'item',
      url: '/settings/external-service-configurations',
      icon: { anticon: icons.ApiOutlined },
      rights: [Rights.ListIntegrations]
    },
    {
      id: 'config-fees-list',
      title: 'Fee Presets',
      type: 'item',
      url: '/settings/fees',
      icon: { anticon: icons.PercentageOutlined },
      rights: [Rights.ListIntegrations]
    },
    {
      id: 'permissions-list',
      title: 'Permissions',
      type: 'item',
      url: '/settings/permissions',
      icon: { anticon: icons.SafetyOutlined },
      rights: [Rights.IsSuperAdmin]
    }
  ]
};

export default settings;
